import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
/** lib **/
import SwiperCore from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/scss';
import classNames from 'classnames';
import { SERVICE_NAME } from '../../const';
import { SupporterVoiceList } from 'lib/supporter-voice';
/** components **/
import { ContentsTitle } from '../molecules';
import { FadeUp, ParallaxItem } from 'components/organisms';
/** styles,images **/
import s from '../../styles/organisms/top-supporter-voice.module.scss';
import { ReactComponent as BlackCircleArrow } from 'assets/images/black-circle-arrow.svg';
import { ReactComponent as GreenCircleArrow } from 'assets/images/green-circle-arrow.svg';
import BgLogo from 'assets/images/bg-logo.svg';
import Pwan from 'assets/images/pwan.png';

export const TopSupporterVoice: React.FC = () => {
  const swiperRef = useRef<SwiperCore>();
  const SwiperButtonPrev = (): JSX.Element => {
    return (
      <button onClick={() => swiperRef.current?.slidePrev()}>
        <BlackCircleArrow className={classNames(s.navButton, s.prevButton)} />
      </button>
    );
  };

  const SwiperButtonNext = (): JSX.Element => {
    return (
      <button onClick={() => swiperRef.current?.slideNext()}>
        <BlackCircleArrow className={classNames(s.navButton, s.nextButton)} />
      </button>
    );
  };
  return (
    <div className={s.supporterVoiceWrapper}>
      <FadeUp delay={0}>
        <div className={s.contentsTitleWrapper}>
          <ContentsTitle
            className={s.contentsTitle}
            title={`SUPPORTER’S VOICE`}
            subTitle="ご登録いただいたサポーターの声"
          />
          <Link className={classNames(s.moreLink, s.pcOnly)} to="/supporters-voice">
            <p>もっと見る</p>
            <GreenCircleArrow className={s.moreLinkIcon} />
          </Link>
        </div>
      </FadeUp>
      <FadeUp>
        <div className={s.inner}>
          <Swiper
            className={s.slideWrapper}
            onBeforeInit={(swiper: SwiperCore) => {
              swiperRef.current = swiper;
            }}
            spaceBetween={24}
            speed={700}
            slidesPerView={1.3}
            loop={false}
            breakpoints={{
              1024: {
                slidesPerView: 'auto',
                spaceBetween: 24,
              },
            }}
          >
            {[...SupporterVoiceList].reverse().slice(0, 4).map((item, index) => (
              <SwiperSlide className={s.item} key={index}>
                <img src={require(`assets/images/${item.image}`)} alt={item.spec} />
                <div className={s.text}>
                  <p className={s.spec}>{item.spec}</p>
                  <p>{item.text}</p>
                </div>
              </SwiperSlide>
            ))}
            <div className={s.navWrapper}>
              <SwiperButtonPrev />
              <SwiperButtonNext />
            </div>
          </Swiper>
        </div>
        <Link className={classNames(s.moreLink, s.spOnly)} to="/supporters-voice">
          <p>もっと見る</p>
          <GreenCircleArrow className={s.moreLinkIcon} />
        </Link>
      </FadeUp>
      <div className={s.interView}>
        <ContentsTitle
          className={s.contentsTitle}
          title={`SUPPORTER’S REPORT`}
          subTitle="インタビューでいただいたサポーターの皆さまからの声をまとめました"
        />
        <Link className={s.linkToForm} to="interview">
          皆さまからの声
          <GreenCircleArrow className={s.arrowIcon} />
        </Link>

        <div className={s.notice}>
          <p>皆さまのご意見をまとめたよ！</p>
          <img src={Pwan} alt="ピーワン" />
        </div>
      </div>
      <ParallaxItem className={s.parallaxBg}>
        <img src={BgLogo} alt={SERVICE_NAME} />
      </ParallaxItem>
    </div>
  );
};
